import { render, staticRenderFns } from "./FacialFeatureTraitPreview.vue?vue&type=template&id=43fdd3cb&scoped=true&"
import script from "./FacialFeatureTraitPreview.vue?vue&type=script&lang=ts&"
export * from "./FacialFeatureTraitPreview.vue?vue&type=script&lang=ts&"
import style0 from "./FacialFeatureTraitPreview.vue?vue&type=style&index=0&id=43fdd3cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fdd3cb",
  null
  
)

export default component.exports